// Markdown -> HTML for loading saved markdown into the TipTap-based
// MarkdownEditor (which parses HTML into its schema and drops anything it
// doesn't support). Uses the same react-markdown + GFM pipeline as
// components/Markdown so both agree on how text is read.
import { createElement } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export function markdownToHtml(markdown: string): string {
  if (!markdown.trim()) return "";
  return renderToStaticMarkup(createElement(ReactMarkdown, { remarkPlugins: [remarkGfm] }, markdown));
}
